import ReceivableScreen from './index';
import DetailScreen from './detail';
import CreateScreen from './create';
import UpdateScreen from './update';

const routes = [
  {
    path: '/payable',
    component: ReceivableScreen,
  },
  {
    path: '/payable/create',
    component: CreateScreen,
  },
  {
    path: '/payable/:id',
    component: DetailScreen,
  },
  {
    path: '/payable/update/:id',
    component: UpdateScreen,
  },
];

export default routes;
